var map = {
	"./arrow_down.svg": "./src/assets/icons/arrow_down.svg",
	"./arrow_right.svg": "./src/assets/icons/arrow_right.svg",
	"./arrow_right_black.svg": "./src/assets/icons/arrow_right_black.svg",
	"./arrow_white_left.svg": "./src/assets/icons/arrow_white_left.svg",
	"./calendar.svg": "./src/assets/icons/calendar.svg",
	"./caret_down.svg": "./src/assets/icons/caret_down.svg",
	"./caret_left.svg": "./src/assets/icons/caret_left.svg",
	"./caret_right.svg": "./src/assets/icons/caret_right.svg",
	"./check-icon.svg": "./src/assets/icons/check-icon.svg",
	"./download_icon.svg": "./src/assets/icons/download_icon.svg",
	"./hamburger.svg": "./src/assets/icons/hamburger.svg",
	"./hb-icon-close.svg": "./src/assets/icons/hb-icon-close.svg",
	"./hb-icon-comfort.svg": "./src/assets/icons/hb-icon-comfort.svg",
	"./hb-icon-desk-booking.svg": "./src/assets/icons/hb-icon-desk-booking.svg",
	"./hb-icon-energy-consumption.svg": "./src/assets/icons/hb-icon-energy-consumption.svg",
	"./hb-icon-logout.svg": "./src/assets/icons/hb-icon-logout.svg",
	"./hb-icon-users.svg": "./src/assets/icons/hb-icon-users.svg",
	"./logo-symbiosy.svg": "./src/assets/icons/logo-symbiosy.svg",
	"./logo.svg": "./src/assets/icons/logo.svg",
	"./logout_black.svg": "./src/assets/icons/logout_black.svg",
	"./ok.svg": "./src/assets/icons/ok.svg",
	"./problem.svg": "./src/assets/icons/problem.svg",
	"./settings.svg": "./src/assets/icons/settings.svg",
	"./sort_down.svg": "./src/assets/icons/sort_down.svg",
	"./steps.svg": "./src/assets/icons/steps.svg",
	"./warning.svg": "./src/assets/icons/warning.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/icons sync recursive ^\\.\\/.*$";